import { Box } from "@chakra-ui/react";
import {
  MdCreditCard,
  MdPeople,
  MdStorefront,
  MdWorkspaces,
} from "react-icons/md";
import { gql } from "__generated__/gql";
import Layout, { LayoutProps } from "components/Layout";
import { useBrandQuery } from "utils/apollo/hooks/brand";
import { useCurrentBrandData, useCurrentBrandId } from "utils/currentUserHooks";
import {
  BRAND_BILLING,
  BRAND_CHILDREN,
  BRAND_SETTINGS,
  BRAND_USER_SETTINGS,
} from "utils/links";
import NavLink from "./NavLink";

type Props = LayoutProps;

const query = gql(/* GraphQL */ `
  query BrandSettingsLayout($brandId: UUID!) {
    brand(id: $brandId) {
      id
      isParent
    }
  }
`);

export default function BrandSettingsLayout({ children, ...rest }: Props) {
  const brandId = useCurrentBrandId();
  const brand = useCurrentBrandData();
  const { data } = useBrandQuery(query, {
    skip: !brandId || !brand,
    variables: brandId ? { brandId } : undefined,
    returnPartialData: true,
  });
  return (
    <Layout display="flex" flexWrap="wrap" alignItems="flex-start" {...rest}>
      <Box as="nav" flex="0 0 auto" py={8} pl={8}>
        <NavLink href={BRAND_SETTINGS} IconComponent={MdStorefront}>
          Brand Details
        </NavLink>

        <NavLink href={BRAND_USER_SETTINGS} IconComponent={MdPeople}>
          Users
        </NavLink>

        <NavLink
          href={BRAND_BILLING}
          IconComponent={MdCreditCard}
          exactPathname={false}
        >
          Subscription & Billing
        </NavLink>

        {data?.brand?.isParent && (
          <NavLink href={BRAND_CHILDREN} IconComponent={MdWorkspaces}>
            Sub-Brands
          </NavLink>
        )}
      </Box>

      <Box flex="1 1 30rem" minW="15rem" p={8}>
        {children}
      </Box>
    </Layout>
  );
}

export const getLayout = (page: React.ReactElement) => (
  <BrandSettingsLayout>{page}</BrandSettingsLayout>
);
